/**
 * The words a permission is shown in: an action (`perm.verb.<verb>`) on a thing
 * (`perm.thing.<thing>`), read from its key — `leave.requests.approve` is «الطلبات: يعتمد». One
 * dictionary for every unit, so a unit's permissions have words without its manifest changing; a
 * thing a module names differently is `perm.thing.<module>.<thing>`, and a permission the generic
 * words would mislead about is `perm.<key>`. Then the role-permissions page's own words.
 * Generated once from the reviewed table and kept by hand since.
 */
export const PERMISSIONS_EN = {
    // An action, the verb a permission’s key ends in.
    'perm.verb.view': 'View',
    'perm.verb.read': 'View',
    'perm.verb.view_all': 'View everything',
    'perm.verb.manage': 'Manage',
    'perm.verb.approve': 'Approve',
    'perm.verb.export': 'Export',
    'perm.verb.create': 'Create',
    'perm.verb.record': 'Record',
    'perm.verb.decide': 'Decide',
    'perm.verb.issue': 'Issue',
    'perm.verb.submit': 'Submit',
    'perm.verb.assign': 'Assign',
    'perm.verb.close': 'Close',
    'perm.verb.update': 'Edit',
    'perm.verb.import': 'Import',
    'perm.verb.request': 'Request',
    'perm.verb.open': 'Open',
    'perm.verb.sign': 'Sign',
    'perm.verb.review': 'Review',
    'perm.verb.cancel': 'Cancel',
    'perm.verb.post': 'Post',
    'perm.verb.adjust': 'Adjust',
    'perm.verb.upload': 'Upload',
    'perm.verb.use': 'Use',
    'perm.verb.assess': 'Assess',
    'perm.verb.lock': 'Lock',
    'perm.verb.complete': 'Complete',
    'perm.verb.pay': 'Pay',
    'perm.verb.propose': 'Propose',
    'perm.verb.edit': 'Edit',
    'perm.verb.check': 'Check in and out',
    'perm.verb.configure': 'Configure',
    'perm.verb.reconcile': 'Reconcile',
    'perm.verb.notify': 'Notify',
    'perm.verb.send': 'Send',
    'perm.verb.resend': 'Send again',
    'perm.verb.all': 'Everything',
    'perm.verb.reply': 'Reply',
    'perm.verb.invite': 'Invite',
    'perm.verb.remove': 'Remove',
    'perm.verb.password': 'Reset the password',
    'perm.verb.move': 'Move',
    'perm.verb.share': 'Share',
    'perm.verb.delete': 'Delete',
    'perm.verb.merge': 'Merge',
    'perm.verb.return': 'Take back',
    'perm.verb.finance': 'Charge the cost',
    'perm.verb.run': 'Run',
    'perm.verb.correct': 'Correct',
    'perm.verb.ingest': 'Receive',
    'perm.verb.approve_hr': 'Approve for HR',
    'perm.verb.generate': 'Generate',
    'perm.verb.settle': 'Settle',
    'perm.verb.join': 'Join',
    'perm.verb.prepare': 'Prepare',
    'perm.verb.fill': 'Fill in',
    'perm.verb.sources': 'Choose the reviewers',
    'perm.verb.hire': 'Hire',
    'perm.verb.publish': 'Publish',
    'perm.verb.edit_after_lock': 'Edit after locking',
    'perm.verb.file': 'File the return',
    'perm.verb.swap': 'Swap',
    'perm.verb.confirm': 'Confirm',
    'perm.verb.adopt': 'Adopt',
    'perm.verb.reverse': 'Reverse',
    'perm.verb.credit': 'Issue a credit note',
    'perm.verb.items': 'Manage the lines',
    'perm.verb.file_vat': 'File the VAT return',
    'perm.verb.export_confirm': 'Confirm the export',
    'perm.verb.discount_unlimited': 'Discount without a limit',
    'perm.verb.reassign': 'Reassign',
    'perm.verb.assign_vehicle': 'Assign a vehicle',
    'perm.verb.upgrade': 'Upgrade the class',
    'perm.verb.override_capacity': 'Override capacity',
    'perm.verb.waive_deposit': 'Waive the deposit',
    'perm.verb.record_deposit': 'Record the deposit',
    'perm.verb.extend': 'Extend',
    'perm.verb.swap_vehicle': 'Swap the vehicle',
    'perm.verb.verify': 'Verify',
    'perm.verb.add': 'Add',
    'perm.verb.lift': 'Lift',
    'perm.verb.record_response': 'Record the response',
    'perm.verb.decide_objection': 'Decide the objection',
    'perm.verb.record_objection': 'Record the objection',
    'perm.verb.transfer': 'Transfer',
    'perm.verb.charge': 'Charge',
    'perm.verb.renew': 'Renew',
    'perm.verb.block': 'Block',
    'perm.verb.record_arrival': 'Record the arrival',
    'perm.verb.change_category': 'Change the class',
    'perm.verb.record_payment': 'Record the payment',
    'perm.verb.withdraw': 'Withdraw',
    'perm.verb.submit_for_check': 'Send for checking',
    'perm.verb.retry': 'Retry',
    'perm.verb.record_manual': 'Record by hand',
    'perm.verb.register': 'Register',
    'perm.verb.triage': 'Triage',
    'perm.verb.suspend': 'Suspend',
    'perm.verb.report': 'Report',
    'perm.verb.qualify': 'Qualify',
    'perm.verb.receive': 'Receive',
    // A thing, the part of the key between the module and the action.
    'perm.thing.absences': 'Absences',
    'perm.thing.access': 'Access',
    'perm.thing.acquisitions': 'Acquisitions',
    'perm.thing.address': 'Address',
    'perm.thing.advances': 'Advances',
    'perm.thing.agreements': 'Agreements',
    'perm.thing.all': 'All',
    'perm.thing.analyses': 'Analyses',
    'perm.thing.announcements': 'Announcements',
    'perm.thing.applications': 'Applications',
    'perm.thing.approval_limit': 'Approval limit',
    'perm.thing.areas': 'Areas',
    'perm.thing.assessments': 'Assessments',
    'perm.thing.assignment': 'Assignment',
    'perm.thing.assignment_approvals': 'Assignment approvals',
    'perm.thing.assignments': 'Assignments',
    'perm.thing.associations': 'Associations',
    'perm.thing.attendance': 'Attendance',
    'perm.thing.balances': 'Balances',
    'perm.thing.bank_account': 'Bank account',
    'perm.thing.bank_file': 'Bank file',
    'perm.thing.blacklist': 'Blacklist',
    'perm.thing.booking': 'Booking',
    'perm.thing.branch': 'Branch',
    'perm.thing.breaches': 'Breaches',
    'perm.thing.budgets': 'Budgets',
    'perm.thing.buyer_contracts': 'Buyer contracts',
    'perm.thing.campaigns': 'Campaigns',
    'perm.thing.candidates': 'Candidates',
    'perm.thing.capture': 'Capture',
    'perm.thing.case': 'Case',
    'perm.thing.cases': 'Cases',
    'perm.thing.catalogue': 'Catalogue',
    'perm.thing.certificate': 'Certificate',
    'perm.thing.certificates': 'Certificates',
    'perm.thing.checklist': 'Checklist',
    'perm.thing.claim': 'Claim',
    'perm.thing.clearance': 'Clearance',
    'perm.thing.collections': 'Collections',
    'perm.thing.committee': 'Committee',
    'perm.thing.common_areas': 'Common areas',
    'perm.thing.compensation': 'Individual pay',
    'perm.thing.complaints': 'Complaints',
    'perm.thing.connections': 'Connections',
    'perm.thing.consents': 'Consents',
    'perm.thing.contract': 'Contract',
    'perm.thing.contracts': 'Contracts',
    'perm.thing.corrections': 'Corrections',
    'perm.thing.coverage': 'Coverage',
    'perm.thing.custody': 'Custody',
    'perm.thing.customer': 'Customer',
    'perm.thing.damage': 'Damage',
    'perm.thing.deals': 'Deals',
    'perm.thing.definitions': 'Definitions',
    'perm.thing.deliveries': 'Deliveries',
    'perm.thing.developer_agreements': 'Developer agreements',
    'perm.thing.devices': 'Devices',
    'perm.thing.discount_approvals': 'Discount approvals',
    'perm.thing.document': 'Document',
    'perm.thing.documents': 'Documents',
    'perm.thing.drawdowns': 'Drawdowns',
    'perm.thing.entries': 'Entries',
    'perm.thing.envelopes': 'Envelopes',
    'perm.thing.escrow_accounts': 'Escrow accounts',
    'perm.thing.evidence': 'Medical attachments',
    'perm.thing.expiries': 'Expiries',
    'perm.thing.export': 'Export',
    'perm.thing.fees': 'Fees',
    'perm.thing.fields': 'Fields',
    'perm.thing.files': 'Files',
    'perm.thing.fine': 'Fine',
    'perm.thing.funds': 'Funds',
    'perm.thing.grades': 'Grades',
    'perm.thing.grievances': 'Grievances',
    'perm.thing.handovers': 'Handovers',
    'perm.thing.holds': 'Holds',
    'perm.thing.identity': 'Identity',
    'perm.thing.inbox': 'Inbox',
    'perm.thing.indicators': 'Indicators',
    'perm.thing.inquiries': 'Inquiries',
    'perm.thing.inspections': 'Inspections',
    'perm.thing.inventory': 'Inventory',
    'perm.thing.item': 'Item',
    'perm.thing.items': 'Items',
    'perm.thing.journeys': 'Onboarding journeys',
    'perm.thing.layers': 'Layers',
    'perm.thing.leads': 'Leads',
    'perm.thing.leases': 'Leases', // domain-neutral: allow — a domain unit's permission word in the one shared dictionary
    'perm.thing.leave': 'Leave',
    'perm.thing.letters': 'Letters',
    'perm.thing.licences': 'Licences',
    'perm.thing.listings': 'Listings',
    'perm.thing.loans': 'Loans',
    'perm.thing.locations': 'Locations',
    'perm.thing.mandates': 'Mandates',
    'perm.thing.meetings': 'Meetings',
    'perm.thing.members': 'Members',
    'perm.thing.meters': 'Meters',
    'perm.thing.module': 'Module',
    'perm.thing.movements': 'Movements',
    'perm.thing.moves': 'Moves',
    'perm.thing.occasions': 'Occasions',
    'perm.thing.offers': 'Offers',
    'perm.thing.opportunities': 'Opportunities',
    'perm.thing.orders': 'Orders',
    'perm.thing.outages': 'Outages',
    'perm.thing.own': 'Their own',
    'perm.thing.parcels': 'Parcels',
    'perm.thing.parts': 'Parts',
    'perm.thing.party_messages': 'Party messages',
    'perm.thing.patterns': 'Patterns',
    'perm.thing.payment': 'Payment',
    'perm.thing.payslips': 'Payslips',
    'perm.thing.performance': 'Performance',
    'perm.thing.period': 'Period',
    'perm.thing.periods': 'Periods',
    'perm.thing.plan': 'Plan',
    'perm.thing.plans': 'Plans',
    'perm.thing.policies': 'Policies',
    'perm.thing.policy': 'Policy',
    'perm.thing.portfolios': 'Portfolios',
    'perm.thing.posts': 'Feed posts',
    'perm.thing.prep': 'Prep',
    'perm.thing.preventive': 'Preventive',
    'perm.thing.price': 'Price',
    'perm.thing.profile': 'Profile',
    'perm.thing.profiles': 'Profiles',
    'perm.thing.programmes': 'Programmes',
    'perm.thing.projects': 'Projects',
    'perm.thing.properties': 'Properties',
    'perm.thing.rates': 'Rates',
    'perm.thing.ratio': 'Saudization ratio',
    'perm.thing.readings': 'Readings',
    'perm.thing.records': 'Records',
    'perm.thing.register': 'Register',
    'perm.thing.registry': 'Registry',
    'perm.thing.regulatory_reports': 'Regulatory reports',
    'perm.thing.releases': 'Releases',
    'perm.thing.report': 'Report',
    'perm.thing.reports': 'Reports',
    'perm.thing.requests': 'Requests',
    'perm.thing.reservation_extensions': 'Reservation extensions',
    'perm.thing.reservations': 'Reservations',
    'perm.thing.restriction': 'Restriction',
    'perm.thing.reviews': 'Reviews',
    'perm.thing.role': 'Roles',
    'perm.thing.rules': 'Rules',
    'perm.thing.runs': 'Runs',
    'perm.thing.schedule': 'Schedule',
    'perm.thing.schedules': 'Schedules',
    'perm.thing.settings': 'Settings',
    'perm.thing.settlements': 'Settlements',
    'perm.thing.setup': 'Setup',
    'perm.thing.shares': 'Shares',
    'perm.thing.shift': 'Shift',
    'perm.thing.shifts': 'Shifts',
    'perm.thing.signals': 'Signals',
    'perm.thing.signatures': 'Signatures',
    'perm.thing.site_models': 'Site models',
    'perm.thing.sites': 'Sites',
    'perm.thing.sources': 'Sources',
    'perm.thing.statements': 'Statements',
    'perm.thing.stores': 'Stores',
    'perm.thing.transfers': 'Transfers',
    'perm.thing.structure': 'Structure',
    'perm.thing.submission': 'Submission',
    'perm.thing.submissions': 'Submissions',
    'perm.thing.swaps': 'Swaps',
    'perm.thing.systems': 'Systems',
    'perm.thing.target': 'Target',
    'perm.thing.team': 'Team',
    'perm.thing.targets': 'Targets',
    'perm.thing.teams': 'Teams',
    'perm.thing.templates': 'Templates',
    'perm.thing.tenant': 'The workspace',
    'perm.thing.thresholds': 'Thresholds',
    'perm.thing.tickets': 'Tickets',
    'perm.thing.time': 'Time',
    'perm.thing.titles': 'Title deeds',
    'perm.thing.transactions': 'Transactions',
    'perm.thing.transfer': 'Transfer',
    'perm.thing.travel': 'Travel',
    'perm.thing.types': 'Types',
    'perm.thing.units': 'Units',
    'perm.verb.manual': 'Set by hand',
    'perm.verb.remind': 'Send reminders',
    'perm.verb.make': 'Make',
    'perm.verb.stop': 'Stop',
    'perm.verb.redeem': 'Redeem',
    'perm.verb.launch': 'Launch',
    'perm.thing.employees.numbering': 'Employee numbering',
    'perm.thing.accounting.write_off': 'Write-offs',
    'perm.thing.invoicing.reminder': 'Payment reminders',
    'perm.thing.invoicing.billing': 'Billing requests',
    'perm.thing.notifications.alerts': 'Notification alerts',
    'perm.thing.attachments.views': 'Who viewed a file',
    'perm.thing.ads.creatives': 'Ad creatives',
    'perm.thing.ads.accounts': 'Ad accounts',
    'perm.thing.ads.changes': 'Ad changes',
    'perm.thing.ads.advertisers': 'Advertisers',
    'perm.thing.ads.measure': 'Ad measurement',
    'perm.thing.audiences.audiences': 'Audiences',
    'perm.thing.captures.forms': 'Capture forms',
    'perm.thing.sends.sends': 'Sends',
    'perm.thing.user': 'People',
    'perm.thing.vacancies': 'Vacancies',
    'perm.thing.valuations': 'Valuations',
    'perm.thing.vat': 'VAT',
    'perm.thing.vehicle': 'Vehicle',
    'perm.thing.vendors': 'Vendors',
    'perm.thing.view': 'View',
    'perm.thing.viewings': 'Viewings',
    'perm.thing.views': 'Views',
    'perm.thing.violations': 'Violations',
    'perm.thing.visits': 'Visits',
    'perm.thing.waiting': 'Waiting on someone',
    'perm.thing.work_order': 'Work order',
    'perm.thing.work_orders': 'Work orders',
    'perm.thing.workshop': 'Workshop',
    // A thing named differently in one module.
    'perm.thing.employees.items': 'Employee files',
    'perm.thing.muqeem.items': 'Muqeem records',
    'perm.thing.grievances.items': 'Grievances',
    'perm.thing.rewards.items': 'Rewards',
    'perm.thing.onboarding.items': 'Onboarding tasks',
    'perm.thing.assets.items': 'Custody items',
    'perm.thing.identity.member_role': 'People’s roles',
    // A whole permission whose generic words would mislead.
    'perm.thing.employees.scope': 'Every department',
    'perm.employees.scope.all': 'See and decide for every department, not only the ones they manage',
    'perm.identity.user.manage': 'Edit their details',
    'perm.identity.user.invite': 'Add and invite',
    'perm.identity.user.remove': 'Suspend and remove',
    'perm.identity.user.assign': 'Give and take away roles',
    'perm.identity.role.manage': 'Manage and set permissions',
    'perm.thing.identity.portal': 'Portal members',
    'perm.identity.portal.view': 'See who outside the workspace signs in to its portal',
    'perm.identity.portal.invite': 'Invite parties to the portal',
    'perm.identity.portal.manage': 'Suspend and resume portal accounts',
    // The role-permissions page.
    'rp.title': 'Set permissions',
    'screen.identity.role_permissions.title': 'Set permissions',
    'rp.general': 'General',
    'rp.held_by': 'Held by {n}',
    'rp.granted': '{granted} of {total} granted',
    'rp.of': '{n} of {total}',
    'rp.added': '+{n} added',
    'rp.removed': '−{n} taken away',
    'rp.sensitive_count': '{n} sensitive',
    'rp.no_changes': 'No changes',
    'rp.undo': 'Undo all',
    'rp.review': 'Review and save',
    'rp.search': 'Search every unit: approve, payroll, contracts…',
    'rp.show.all': 'All',
    'rp.show.granted': 'Granted',
    'rp.show.changed': 'Changed',
    'rp.show.sensitive': 'Sensitive',
    'rp.start_from': 'Start from a role…',
    'rp.start_from.copy': 'Copy «{role}»',
    'rp.start_from.empty': 'Start empty',
    'rp.level.0': 'None',
    'rp.level.1': 'View',
    'rp.level.2': 'Work',
    'rp.level.3': 'Manage',
    'rp.level.label': 'Level for {module}',
    'rp.custom': 'Custom',
    'rp.matches': '{n} match',
    'rp.changed': 'Changed here',
    'rp.pick': 'Pick a module to see its permissions.',
    'rp.nothing': 'Nothing matches. Try another word.',
    'rp.nothing_changed': 'You have not changed anything yet.',
    'rp.only_matches': 'showing only what matches',
    'rp.sensitive_here': 'Sensitive, granted here:',
    'rp.legend.add': 'Will be granted',
    'rp.legend.remove': 'Will be taken away',
    'rp.legend.sensitive': 'Sensitive',
    'rp.legend.levels': 'View → Work → Manage',
    'rp.legend.key': 'Hover a permission to see its key.',
    'rp.locked': 'You do not hold this, so you cannot give it',
    'rp.sensitive': 'Sensitive permission',
    'rp.system': 'A role every workspace has: its permissions are shown here and not changed. Duplicate it to change a copy.',
    'rp.read_only': 'You can read what this role may do. Changing it needs the permission to manage roles.',
    'rp.duplicate': 'Duplicate to edit',
    'rp.back': 'Back to the role',
    'rp.not_found': 'No such role in this workspace.',
    'rp.review.title': 'Review before saving',
    'rp.review.lede': 'This applies to everyone holding «{role}» as soon as it is saved.',
    'rp.review.added': 'Will be able to',
    'rp.review.removed': 'Will no longer be able to',
    'rp.review.sensitive': 'Sensitive permissions to be granted ({n}):',
    'rp.review.second_factor': 'This role asks for two-step sign-in, so they work only for whoever has turned it on.',
    'rp.review.back': 'Back to editing',
    'rp.review.save': 'Save changes',
    'rp.review.saving': 'Saving…',
    'rp.review.saved': 'Saved. Everyone holding the role has them from their next sign-in.',
    'rp.review.atomic': 'Saved whole or not at all, and recorded in the role’s history under your name. If somebody changes this role meanwhile, your changes are added to theirs, not written over them.',
    'rp.review.holders': 'Who is affected',
    'rp.review.holders_none': 'Nobody holds this role yet.',
};
export const PERMISSIONS_AR = {
    // An action, the verb a permission’s key ends in.
    'perm.verb.view': 'يرى',
    'perm.verb.read': 'يرى',
    'perm.verb.view_all': 'يرى الكل',
    'perm.verb.manage': 'يدير',
    'perm.verb.approve': 'يعتمد',
    'perm.verb.export': 'يصدّر',
    'perm.verb.create': 'يُنشئ',
    'perm.verb.record': 'يسجّل',
    'perm.verb.decide': 'يقرّر',
    'perm.verb.issue': 'يُصدر',
    'perm.verb.submit': 'يقدّم',
    'perm.verb.assign': 'يُسند',
    'perm.verb.close': 'يُغلق',
    'perm.verb.update': 'يعدّل',
    'perm.verb.import': 'يستورد',
    'perm.verb.request': 'يطلب',
    'perm.verb.open': 'يفتح',
    'perm.verb.sign': 'يوقّع',
    'perm.verb.review': 'يراجع',
    'perm.verb.cancel': 'يلغي',
    'perm.verb.post': 'يرحّل',
    'perm.verb.adjust': 'يسوّي',
    'perm.verb.upload': 'يرفع',
    'perm.verb.use': 'يستخدم',
    'perm.verb.assess': 'يقيّم',
    'perm.verb.lock': 'يقفل',
    'perm.verb.complete': 'يُنجز',
    'perm.verb.pay': 'يصرف',
    'perm.verb.propose': 'يقترح',
    'perm.verb.edit': 'يعدّل',
    'perm.verb.check': 'يسجّل البصمة',
    'perm.verb.configure': 'يضبط',
    'perm.verb.reconcile': 'يطابق',
    'perm.verb.notify': 'يُشعر',
    'perm.verb.send': 'يرسل',
    'perm.verb.resend': 'يعيد الإرسال',
    'perm.verb.all': 'كل شيء',
    'perm.verb.reply': 'يردّ',
    'perm.verb.invite': 'يدعو',
    'perm.verb.remove': 'يزيل',
    'perm.verb.password': 'يعيد كلمة المرور',
    'perm.verb.move': 'ينقل',
    'perm.verb.share': 'يشارك',
    'perm.verb.delete': 'يحذف',
    'perm.verb.merge': 'يدمج',
    'perm.verb.return': 'يستلم المرتجع',
    'perm.verb.finance': 'يحمّل التكلفة',
    'perm.verb.run': 'يشغّل',
    'perm.verb.correct': 'يصحّح',
    'perm.verb.ingest': 'يستقبل',
    'perm.verb.approve_hr': 'يعتمد بصفة الموارد البشرية',
    'perm.verb.generate': 'يولّد',
    'perm.verb.settle': 'يسوّي مالياً',
    'perm.verb.join': 'ينضم',
    'perm.verb.prepare': 'يعدّ',
    'perm.verb.fill': 'يملأ',
    'perm.verb.sources': 'يحدد المقيّمين',
    'perm.verb.hire': 'يعيّن',
    'perm.verb.publish': 'ينشر',
    'perm.verb.edit_after_lock': 'يعدّل بعد الإقفال',
    'perm.verb.file': 'يقدّم الإقرار',
    'perm.verb.swap': 'يبدّل',
    'perm.verb.confirm': 'يؤكد',
    'perm.verb.adopt': 'يعتمد للتطبيق',
    'perm.verb.reverse': 'يعكس',
    'perm.verb.credit': 'يُصدر إشعاراً دائناً',
    'perm.verb.items': 'يدير البنود',
    'perm.verb.file_vat': 'يقدّم إقرار الضريبة',
    'perm.verb.export_confirm': 'يؤكد التصدير',
    'perm.verb.discount_unlimited': 'يخصم بلا حدّ',
    'perm.verb.reassign': 'يعيد الإسناد',
    'perm.verb.assign_vehicle': 'يخصّص سيارة',
    'perm.verb.upgrade': 'يرقّي الفئة',
    'perm.verb.override_capacity': 'يتجاوز السعة',
    'perm.verb.waive_deposit': 'يعفي من التأمين',
    'perm.verb.record_deposit': 'يسجّل التأمين',
    'perm.verb.extend': 'يمدّد',
    'perm.verb.swap_vehicle': 'يبدّل السيارة',
    'perm.verb.verify': 'يتحقق',
    'perm.verb.add': 'يضيف',
    'perm.verb.lift': 'يرفع القيد',
    'perm.verb.record_response': 'يسجّل الرد',
    'perm.verb.decide_objection': 'يبتّ في الاعتراض',
    'perm.verb.record_objection': 'يسجّل الاعتراض',
    'perm.verb.transfer': 'يحوّل',
    'perm.verb.charge': 'يحمّل المبلغ',
    'perm.verb.renew': 'يجدّد',
    'perm.verb.block': 'يوقف',
    'perm.verb.record_arrival': 'يسجّل الوصول',
    'perm.verb.change_category': 'يغيّر الفئة',
    'perm.verb.record_payment': 'يسجّل الدفعة',
    'perm.verb.withdraw': 'يسحب',
    'perm.verb.submit_for_check': 'يرسل للفحص',
    'perm.verb.retry': 'يعيد المحاولة',
    'perm.verb.record_manual': 'يسجّل يدوياً',
    'perm.verb.register': 'يسجّل',
    'perm.verb.triage': 'يفرز',
    'perm.verb.suspend': 'يعلّق',
    'perm.verb.report': 'يبلّغ',
    'perm.verb.qualify': 'يؤهّل',
    'perm.verb.receive': 'يستلم',
    // A thing, the part of the key between the module and the action.
    'perm.thing.absences': 'الغياب',
    'perm.thing.access': 'الوصول',
    'perm.thing.acquisitions': 'الاستحواذات',
    'perm.thing.address': 'العناوين',
    'perm.thing.advances': 'السلف',
    'perm.thing.agreements': 'الاتفاقيات',
    'perm.thing.all': 'الكل',
    'perm.thing.analyses': 'التحليلات',
    'perm.thing.announcements': 'الإعلانات',
    'perm.thing.applications': 'الطلبات',
    'perm.thing.approval_limit': 'حدود الاعتماد',
    'perm.thing.areas': 'المناطق',
    'perm.thing.assessments': 'التقييمات',
    'perm.thing.assignment': 'الإسناد',
    'perm.thing.assignment_approvals': 'اعتمادات الإسناد',
    'perm.thing.assignments': 'الإسنادات',
    'perm.thing.associations': 'الاتحادات',
    'perm.thing.attendance': 'الحضور',
    'perm.thing.balances': 'الأرصدة',
    'perm.thing.bank_account': 'الحساب البنكي',
    'perm.thing.bank_file': 'ملف البنك',
    'perm.thing.blacklist': 'القائمة المحظورة',
    'perm.thing.booking': 'الحجوزات',
    'perm.thing.branch': 'الفروع',
    'perm.thing.breaches': 'المخالفات',
    'perm.thing.budgets': 'الموازنات',
    'perm.thing.buyer_contracts': 'عقود المشترين',
    'perm.thing.campaigns': 'الحملات',
    'perm.thing.candidates': 'المرشحون',
    'perm.thing.capture': 'الالتقاط',
    'perm.thing.case': 'الحالات',
    'perm.thing.cases': 'الحالات',
    'perm.thing.catalogue': 'الدليل',
    'perm.thing.certificate': 'الشهادات',
    'perm.thing.certificates': 'الشهادات',
    'perm.thing.checklist': 'قائمة التحقق',
    'perm.thing.claim': 'المطالبات',
    'perm.thing.clearance': 'إخلاء الطرف',
    'perm.thing.collections': 'التحصيل',
    'perm.thing.committee': 'اللجنة',
    'perm.thing.common_areas': 'المرافق المشتركة',
    'perm.thing.compensation': 'التعويضات الفردية',
    'perm.thing.complaints': 'الشكاوى',
    'perm.thing.connections': 'الاتصالات',
    'perm.thing.consents': 'الموافقات',
    'perm.thing.contract': 'العقود',
    'perm.thing.contracts': 'العقود',
    'perm.thing.corrections': 'التصحيحات',
    'perm.thing.coverage': 'التغطية',
    'perm.thing.custody': 'العهد',
    'perm.thing.customer': 'العملاء',
    'perm.thing.damage': 'الأضرار',
    'perm.thing.deals': 'الصفقات',
    'perm.thing.definitions': 'التعريفات',
    'perm.thing.deliveries': 'التسليمات',
    'perm.thing.developer_agreements': 'اتفاقيات المطوّرين',
    'perm.thing.devices': 'الأجهزة',
    'perm.thing.discount_approvals': 'اعتمادات الخصم',
    'perm.thing.document': 'الوثائق',
    'perm.thing.documents': 'المستندات',
    'perm.thing.drawdowns': 'السحوبات',
    'perm.thing.entries': 'القيود',
    'perm.thing.envelopes': 'مظاريف التوقيع',
    'perm.thing.escrow_accounts': 'حسابات الضمان',
    'perm.thing.evidence': 'المرفقات الطبية',
    'perm.thing.expiries': 'الانتهاءات',
    'perm.thing.export': 'التصدير',
    'perm.thing.fees': 'الرسوم',
    'perm.thing.fields': 'الحقول',
    'perm.thing.files': 'الملفات',
    'perm.thing.fine': 'المخالفات',
    'perm.thing.funds': 'الصناديق',
    'perm.thing.grades': 'الدرجات',
    'perm.thing.grievances': 'التظلّمات',
    'perm.thing.handovers': 'التسليم',
    'perm.thing.holds': 'الحجوزات المؤقتة',
    'perm.thing.identity': 'الهوية',
    'perm.thing.inbox': 'الوارد',
    'perm.thing.indicators': 'المؤشرات',
    'perm.thing.inquiries': 'الاستفسارات',
    'perm.thing.inspections': 'المعاينات',
    'perm.thing.inventory': 'المخزون',
    'perm.thing.item': 'البنود',
    'perm.thing.items': 'السجلات',
    'perm.thing.journeys': 'رحلات التهيئة',
    'perm.thing.layers': 'الطبقات',
    'perm.thing.leads': 'العملاء المحتملون',
    'perm.thing.leases': 'عقود الإيجار', // domain-neutral: allow — a domain unit's permission word in the one shared dictionary
    'perm.thing.leave': 'الإجازات',
    'perm.thing.letters': 'الخطابات',
    'perm.thing.licences': 'التراخيص',
    'perm.thing.listings': 'العروض',
    'perm.thing.loans': 'القروض',
    'perm.thing.locations': 'المواقع',
    'perm.thing.mandates': 'التفويضات',
    'perm.thing.meetings': 'الاجتماعات',
    'perm.thing.members': 'الأعضاء',
    'perm.thing.meters': 'العدادات',
    'perm.thing.module': 'المديول',
    'perm.thing.movements': 'التنقلات',
    'perm.thing.moves': 'النقل',
    'perm.thing.occasions': 'المناسبات',
    'perm.thing.offers': 'العروض',
    'perm.thing.opportunities': 'الفرص',
    'perm.thing.orders': 'الطلبيات',
    'perm.thing.outages': 'الانقطاعات',
    'perm.thing.own': 'الخاص به',
    'perm.thing.parcels': 'القطع',
    'perm.thing.parts': 'قطع الغيار',
    'perm.thing.party_messages': 'رسائل الأطراف',
    'perm.thing.patterns': 'الأنماط',
    'perm.thing.payment': 'المدفوعات',
    'perm.thing.payslips': 'مفردات الراتب',
    'perm.thing.performance': 'الأداء',
    'perm.thing.period': 'الفترات',
    'perm.thing.periods': 'الفترات',
    'perm.thing.plan': 'الخطة',
    'perm.thing.plans': 'الخطط',
    'perm.thing.policies': 'السياسات',
    'perm.thing.policy': 'الوثائق التأمينية',
    'perm.thing.portfolios': 'المحافظ',
    'perm.thing.posts': 'منشورات الأخبار',
    'perm.thing.prep': 'التجهيز',
    'perm.thing.preventive': 'الصيانة الوقائية',
    'perm.thing.price': 'الأسعار',
    'perm.thing.profile': 'الملف الشخصي',
    'perm.thing.profiles': 'الملفات',
    'perm.thing.programmes': 'البرامج',
    'perm.thing.projects': 'المشاريع',
    'perm.thing.properties': 'العقارات',
    'perm.thing.rates': 'الأسعار',
    'perm.thing.ratio': 'نسبة التوطين',
    'perm.thing.readings': 'القراءات',
    'perm.thing.records': 'السجلات',
    'perm.thing.register': 'السجل',
    'perm.thing.registry': 'السجل',
    'perm.thing.regulatory_reports': 'التقارير النظامية',
    'perm.thing.releases': 'الإصدارات',
    'perm.thing.report': 'المحاضر',
    'perm.thing.reports': 'البلاغات',
    'perm.thing.requests': 'الطلبات',
    'perm.thing.reservation_extensions': 'تمديد الحجوزات',
    'perm.thing.reservations': 'الحجوزات',
    'perm.thing.restriction': 'القيود',
    'perm.thing.reviews': 'التقييمات',
    'perm.thing.role': 'الأدوار',
    'perm.thing.rules': 'القواعد',
    'perm.thing.runs': 'المسيّرات',
    'perm.thing.schedule': 'الجدول',
    'perm.thing.schedules': 'الجداول',
    'perm.thing.settings': 'الإعدادات',
    'perm.thing.settlements': 'التسويات',
    'perm.thing.setup': 'الإعداد',
    'perm.thing.shares': 'الحصص',
    'perm.thing.shift': 'الورديات',
    'perm.thing.shifts': 'الورديات',
    'perm.thing.signals': 'الإشارات',
    'perm.thing.signatures': 'التوقيعات',
    'perm.thing.site_models': 'نماذج المواقع',
    'perm.thing.sites': 'المواقع',
    'perm.thing.sources': 'المصادر',
    'perm.thing.statements': 'الكشوف',
    'perm.thing.stores': 'المستودعات',
    'perm.thing.transfers': 'التحويلات',
    'perm.thing.structure': 'الهيكل',
    'perm.thing.submission': 'الإرساليات',
    'perm.thing.submissions': 'الإرساليات',
    'perm.thing.swaps': 'التبديلات',
    'perm.thing.systems': 'الأنظمة',
    'perm.thing.target': 'المستهدف',
    'perm.thing.team': 'الفريق',
    'perm.thing.targets': 'الأهداف',
    'perm.thing.teams': 'الفرق',
    'perm.thing.templates': 'القوالب',
    'perm.thing.tenant': 'المساحة',
    'perm.thing.thresholds': 'العتبات',
    'perm.thing.tickets': 'التذاكر',
    'perm.thing.time': 'الوقت',
    'perm.thing.titles': 'الصكوك',
    'perm.thing.transactions': 'الصفقات',
    'perm.thing.transfer': 'النقل',
    'perm.thing.travel': 'السفر',
    'perm.thing.types': 'الأنواع',
    'perm.thing.units': 'الوحدات',
    'perm.verb.manual': 'يحدّده يدوياً',
    'perm.verb.remind': 'يرسل التذكيرات',
    'perm.verb.make': 'يُجريها',
    'perm.verb.stop': 'يوقفها',
    'perm.verb.redeem': 'يستخدمها',
    'perm.verb.launch': 'يطلقها',
    'perm.thing.employees.numbering': 'ترقيم الموظفين',
    'perm.thing.accounting.write_off': 'الشطب',
    'perm.thing.invoicing.reminder': 'تذكيرات السداد',
    'perm.thing.invoicing.billing': 'طلبات الفوترة',
    'perm.thing.notifications.alerts': 'تنبيهات الإشعارات',
    'perm.thing.attachments.views': 'من شاهد الملف',
    'perm.thing.ads.creatives': 'التصاميم الإعلانية',
    'perm.thing.ads.accounts': 'الحسابات الإعلانية',
    'perm.thing.ads.changes': 'تغييرات الإعلانات',
    'perm.thing.ads.advertisers': 'المعلنون',
    'perm.thing.ads.measure': 'قياس الإعلانات',
    'perm.thing.audiences.audiences': 'الجماهير',
    'perm.thing.captures.forms': 'نماذج الاستقطاب',
    'perm.thing.sends.sends': 'الإرسالات',
    'perm.thing.user': 'الأشخاص',
    'perm.thing.vacancies': 'الشواغر',
    'perm.thing.valuations': 'التقييمات',
    'perm.thing.vat': 'ضريبة القيمة المضافة',
    'perm.thing.vehicle': 'السيارات',
    'perm.thing.vendors': 'الموردون',
    'perm.thing.view': 'العرض',
    'perm.thing.viewings': 'المعاينات',
    'perm.thing.views': 'طرق العرض',
    'perm.thing.violations': 'المخالفات',
    'perm.thing.visits': 'الزيارات',
    'perm.thing.waiting': 'بانتظار إجراء',
    'perm.thing.work_order': 'أوامر العمل',
    'perm.thing.work_orders': 'أوامر العمل',
    'perm.thing.workshop': 'الورشة',
    // A thing named differently in one module.
    'perm.thing.employees.items': 'ملفات الموظّفين',
    'perm.thing.muqeem.items': 'سجلات مقيم',
    'perm.thing.grievances.items': 'التظلّمات',
    'perm.thing.rewards.items': 'المكافآت',
    'perm.thing.onboarding.items': 'مهام التهيئة',
    'perm.thing.assets.items': 'أصناف العهدة',
    'perm.thing.identity.member_role': 'أدوار الأشخاص',
    // A whole permission whose generic words would mislead.
    'perm.thing.employees.scope': 'كل الأقسام',
    'perm.employees.scope.all': 'يرى ويقرّر لكل الأقسام، لا لما يديره فقط',
    'perm.identity.user.manage': 'يعدّل بياناتهم',
    'perm.identity.user.invite': 'يضيف ويدعو',
    'perm.identity.user.remove': 'يعلّق ويزيل',
    'perm.identity.user.assign': 'يعطي الأدوار ويسحبها',
    'perm.identity.role.manage': 'يدير ويضبط الصلاحيات',
    'perm.thing.identity.portal': 'أعضاء البوابة',
    'perm.identity.portal.view': 'يرى من يدخل بوابة مساحة العمل من خارجها',
    'perm.identity.portal.invite': 'يدعو الأطراف إلى البوابة',
    'perm.identity.portal.manage': 'يعلّق حسابات البوابة ويستأنفها',
    // صفحة ضبط صلاحيات الدور.
    'rp.title': 'ضبط الصلاحيات',
    'screen.identity.role_permissions.title': 'ضبط الصلاحيات',
    'rp.general': 'عام',
    'rp.held_by': 'يحمله {n}',
    'rp.granted': '{granted} ممنوحة من {total}',
    'rp.of': '{n} من {total}',
    'rp.added': '+{n} إضافة',
    'rp.removed': '−{n} سحب',
    'rp.sensitive_count': '{n} حسّاسة',
    'rp.no_changes': 'لا تغييرات',
    'rp.undo': 'تراجع عن الكل',
    'rp.review': 'راجع واحفظ',
    'rp.search': 'ابحث في كل الوحدات: اعتماد، رواتب، عقود…',
    'rp.show.all': 'الكل',
    'rp.show.granted': 'الممنوح',
    'rp.show.changed': 'ما تغيّر',
    'rp.show.sensitive': 'الحسّاس',
    'rp.start_from': 'ابدأ من دور…',
    'rp.start_from.copy': 'انسخ «{role}»',
    'rp.start_from.empty': 'ابدأ فارغاً',
    'rp.level.0': 'لا شيء',
    'rp.level.1': 'يرى',
    'rp.level.2': 'يعمل',
    'rp.level.3': 'يدير',
    'rp.level.label': 'المستوى في {module}',
    'rp.custom': 'مخصّص',
    'rp.matches': '{n} مطابقة',
    'rp.changed': 'تغيّر هنا',
    'rp.pick': 'اختر مديولاً لترى صلاحياته.',
    'rp.nothing': 'لا شيء يطابق. جرّب كلمة أخرى.',
    'rp.nothing_changed': 'لم تغيّر شيئاً بعد.',
    'rp.only_matches': 'يظهر ما يطابق البحث فقط',
    'rp.sensitive_here': 'حسّاسة ممنوحة هنا:',
    'rp.legend.add': 'ستُمنح',
    'rp.legend.remove': 'ستُسحب',
    'rp.legend.sensitive': 'حسّاسة',
    'rp.legend.levels': 'يرى ← يعمل ← يدير',
    'rp.legend.key': 'قف على أي صلاحية لترى مفتاحها.',
    'rp.locked': 'لا تملكها أنت، فلا تستطيع منحها',
    'rp.sensitive': 'صلاحية حسّاسة',
    'rp.system': 'دور موجود في كل مساحة: تُعرض صلاحياته هنا ولا تُعدَّل. كرّره لتعدّل نسخة منه.',
    'rp.read_only': 'تستطيع قراءة ما يمنحه هذا الدور. تغييره يحتاج صلاحية إدارة الأدوار.',
    'rp.duplicate': 'كرّره لتعدّله',
    'rp.back': 'رجوع إلى الدور',
    'rp.not_found': 'لا يوجد هذا الدور في هذه المساحة.',
    'rp.review.title': 'راجع قبل الحفظ',
    'rp.review.lede': 'تسري هذه التغييرات على كل من يحمل «{role}» فور الحفظ.',
    'rp.review.added': 'سيستطيعون',
    'rp.review.removed': 'لن يستطيعوا بعد الحفظ',
    'rp.review.sensitive': 'صلاحيات حسّاسة ستُمنح ({n}):',
    'rp.review.second_factor': 'هذا الدور يطلب التحقق بخطوتين، فلا تعمل إلا لمن فعّله.',
    'rp.review.back': 'ارجع للتعديل',
    'rp.review.save': 'احفظ التغييرات',
    'rp.review.saving': 'جارٍ الحفظ…',
    'rp.review.saved': 'حُفظ. يحصل عليها كل من يحمل الدور من دخوله التالي.',
    'rp.review.atomic': 'يُحفظ التغيير كاملاً أو لا يُحفظ منه شيء، ويُسجَّل في سجل الدور باسمك. وإن غيّر أحد هذا الدور أثناء عملك تُضاف تغييراتك إلى تغييراته ولا تُكتب فوقها.',
    'rp.review.holders': 'من يتأثر',
    'rp.review.holders_none': 'لا أحد يحمل هذا الدور بعد.',
};
//# sourceMappingURL=i18n-permissions.js.map